<style lang="scss">
    @import '~@/abstracts/_variables.scss';

    div#charging-station-legend {
        position: absolute;
        z-index: 9;
        left: 0.5rem;
        bottom: 0.5rem;
        background: #FFFFFF;
        max-width: 220px;
        border-radius: 0.5rem;
        padding: 0.75rem;
        font-family: 'Raleway', sans-serif;
        box-shadow: 0 0 #000000, 0 0 #000000, 0 10px 15px -3px rgba(0,0,0,0.1), 0 4px 6px -4px rgba(0,0,0,0.1);

        span.legend-title {
            display: block;
            text-align: center;
            font-family: 'Raleway', sans-serif;
            margin-bottom: 10px;
            font-size: 16px;
            font-weight: bold;
        }

        div.legend-row {
            margin-bottom: 5px;
            font-size: 14px;

            img {
                margin-right: 10px;
                width: 20px;
            }
        }
    }
</style>

<template>
    <div id="charging-station-legend" v-show="( !showFilters && servicesView == 'map' )">
        <div class="grid-x">
            <div class="large-12 medium-12 small-12 cell">
                <span class="legend-title">{{ $t('legend.label') }}</span>
            </div>
            <div class="large-6 medium-6 small-6 cell legend-row">
                <img src="/img/charging-station-middle-orange-marker-big.svg"/> ≤22 kW
            </div>
            <div class="large-6 medium-6 small-6 cell legend-row">
                <img src="/img/charging-station-aqua-blue-marker-big.svg"/> 50 kW
            </div>
            <div class="large-6 medium-6 small-6 cell legend-row">
                <img src="/img/charging-station-grass-green-marker-big.svg"/> 150 kW
            </div>
            <div class="large-6 medium-6 small-6 cell legend-row">
                <img src="/img/charging-station-petrol-blue-marker-big.svg"/> ≥300 kW
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {

            }
        },

        computed: {
            showFilters() {
                return this.$store.getters.getShowFilters;
            },

            servicesView() {
                return this.$store.getters.getServicesView;
            },
        }
    }
</script>
